import { render, staticRenderFns } from "./PropSelectGroup.vue?vue&type=template&id=5211a897&scoped=true"
import script from "./PropSelectGroup.vue?vue&type=script&lang=ts"
export * from "./PropSelectGroup.vue?vue&type=script&lang=ts"
import style0 from "./PropSelectGroup.vue?vue&type=style&index=0&id=5211a897&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5211a897",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5211a897')) {
      api.createRecord('5211a897', component.options)
    } else {
      api.reload('5211a897', component.options)
    }
    module.hot.accept("./PropSelectGroup.vue?vue&type=template&id=5211a897&scoped=true", function () {
      api.rerender('5211a897', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/prop-select/PropSelectGroup.vue"
export default component.exports